import { Map } from 'immutable';
import { ModalState } from './ModalState';
/**
 * User reducer
 */
export var modalReducer = function (state, action) {
    if (state === void 0) { state = Map(new ModalState()); }
    var payload = action.payload;
    switch (action.type) {
        // case UserActionType.USER_INFO:
        //   return state
        //     .setIn(['info', payload.uid], payload.info)
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/Modal/ModalReducer.ts
// module id = 591
// module chunks = 50